// extracted by mini-css-extract-plugin
export default {"container":"SearchItem_container__9kq54","name":"SearchItem_name__q3rUR","telephone":"SearchItem_telephone__Yuo3V"};